import { RoleEnum } from '@anecdotes/api-contracts';
import { UserType } from '../models';

export function resolveUserTypeByRole(role: RoleEnum): UserType {
  switch (role) {
    case RoleEnum.Admin:
    case RoleEnum.Manager:
      return UserType.GRCOwner;

    case RoleEnum.Contributor:
      return UserType.Collaborator;

    case RoleEnum.It:
    case RoleEnum.Auditor:
    case RoleEnum.Viewer:
    case RoleEnum.Stakeholder:
      return UserType.Free;

    default:
      return UserType.Collaborator;
  }
}
